import React from 'react';
import { CONSTANTS } from '../../data';

interface QuantityControlProps {
  quantity: number;
  onQuantityChange: (newQuantity: number) => void;
  containerWidth: number;
  containerPadding: number;
  elementGap: number;
}

const QuantityControl: React.FC<QuantityControlProps> = ({ 
  quantity, 
  onQuantityChange, 
  containerWidth,
}) => {
  // Check if we're on mobile
  const isMobile = window.innerWidth < CONSTANTS.MOBILE_UI.MOBILE_BREAKPOINT;
  
  // Calculate responsive sizing based on container
  const buttonHeight = Math.max(
    isMobile ? CONSTANTS.BREW_STATION_GRID.MIN_MOBILE_BUTTON_HEIGHT : CONSTANTS.BREW_STATION_GRID.MIN_BUTTON_HEIGHT,
    containerWidth * CONSTANTS.BREW_STATION_GRID.BUTTON_HEIGHT_RATIO
  );
  const textSize = Math.max(
    CONSTANTS.BREW_STATION_GRID.MIN_TEXT_SIZE,
    containerWidth * CONSTANTS.BREW_STATION_GRID.TEXT_SIZE_RATIO
  );
  const buttonSize = Math.max(
    isMobile ? CONSTANTS.BREW_STATION_GRID.MIN_MOBILE_BUTTON_SIZE : CONSTANTS.BREW_STATION_GRID.MIN_BUTTON_SIZE,
    containerWidth * CONSTANTS.BREW_STATION_GRID.BUTTON_SIZE_RATIO
  );

  return (
    <div 
      className="flex items-center justify-center bg-bg-main border border-border-color rounded-lg overflow-hidden"
      style={{ height: `${buttonHeight}px` }}
    >
      <button
        onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
        className="h-full px-2 text-text-secondary hover:bg-border-color transition-colors active:bg-text-secondary active:text-white"
        style={{ fontSize: `${textSize}px`, minWidth: `${Math.max(buttonSize, CONSTANTS.TOUCH_INTERACTION.MIN_TOUCH_TARGET_SIZE * 0.6)}px` }}
      >
        −
      </button>
      <span 
        className="px-2 font-bold text-text-primary"
        style={{ fontSize: `${textSize}px` }}
      >
        {quantity}
      </span>
      <button
        onClick={() => onQuantityChange(quantity + 1)}
        className="h-full px-2 text-text-secondary hover:bg-border-color transition-colors active:bg-text-secondary active:text-white"
        style={{ fontSize: `${textSize}px`, minWidth: `${Math.max(buttonSize, CONSTANTS.TOUCH_INTERACTION.MIN_TOUCH_TARGET_SIZE * 0.6)}px` }}
      >
        +
      </button>
    </div>
  );
};

export default QuantityControl;
